import { css } from '@emotion/react';
import React from 'react';

type MaptiveColorPickerBarPointerProps = Readonly<{
  left: string;
}>;

const barStyle = (left: string) => css({
  boxShadow: 'rgb(0 0 0 / 60%) 0px 0px 2px',
  width: 4,
  top: 1,
  bottom: 1,
  left,
  borderRadius: 1,
  position: 'absolute',
  backgroundColor: '#fff',
});

export const MaptiveColorPickerBarPointerComponent = ({ left }: MaptiveColorPickerBarPointerProps) => {
  return (
    <div css={barStyle(left)} />
  );
};
